import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface Config {
  imposto: number;
  setImposto: (value: number) => void;
}

const ConfigContext = createContext<Config | undefined>(undefined);

export const ConfigProvider = ({ children }: { children: ReactNode }) => {
  const [imposto, setImpostoState] = useState<number>(() => {
    const stored = localStorage.getItem('config:imposto');
    return stored ? parseFloat(stored) : 0.13;
  });

  useEffect(() => {
    localStorage.setItem('config:imposto', imposto.toString());
  }, [imposto]);

  const setImposto = (value: number) => {
    setImpostoState(value);
  };

  return (
    <ConfigContext.Provider value={{ imposto, setImposto }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
}; 